<script>
    import date from '../../../lib/date';
    import OriginalEvent from './item_original.svelte';

    import modals from '../../../state/modals';
    import user from '../../../state/user';

    export let item;

    function orderItem(item) {
        modals.toggleOrderModal(item, ($user && $user.credits > 0));
    }
</script>

<style>
    .item {
        width: 300px;
    }

    time {
        display: block;
    }

    .card-footer-item {
        cursor: pointer;
        color: #3273dc;
    }

    .card-footer-item:hover {
        color: #363636;
    }

    .card-footer-item i {
        margin-right: 5px;
    }
</style>

<div class="card item">
    <div class="card-content">
        <div class="media">
            <div class="media-content">
                <p class="title is-4">{item.rec_caption}</p>
                <p class="subtitle is-6">Délka: {Math.round(item.rec_length / 60)} minut</p>
            </div>
        </div>

        <div class="content">
            {#if item.reo_id}
                <time datetime="{item.reo_created}">Objednána: {date.format(item.reo_created, date.FORMAT_DATETIME_HUMAN)}</time>
                <time datetime="{item.reo_expiration}">Platná do: {date.format(item.reo_expiration, date.FORMAT_DATETIME_HUMAN)}</time>
            {:else}
                {#if false && item.hasEvent > 0}
                    <OriginalEvent {item} />
                {/if}
                <time datetime="{item.rec_created}">Přidána: {date.format(item.rec_created, date.FORMAT_DATE_HUMAN)}</time>
                {#if item.rec_expiration}
                    <time datetime="{item.rec_expiration}">Platná do: {date.format(item.rec_expiration, date.FORMAT_DATE_HUMAN)}</time>
                {:else}
                    <div>Platné do: neomezeno</div>
                {/if}
            {/if}
        </div>
    </div>

    <footer class="card-footer">
        {#if item.url}
            <!-- Owned -->
            <a class="card-footer-item" href="{item.url}">
                <i class="fas fa-play"></i> Sledovat
            </a>
        {:else if item.reo_id}
            <!-- Ordered -->
            <a class="card-footer-item" href="{item.paymentUrl}">
                <i class="fas fa-coin"></i> Zaplatit
            </a>
        {:else}
            <!-- Order -->
            <div class="card-footer-item" on:click={() => orderItem(item)}>
                <i class="fas fa-plus"></i> Objednat
            </div>
        {/if}
    </footer>
</div>
